import type { RegionRepository } from '@/Domain/repositories/RegionRepository';

export const getAll = (repository: RegionRepository) => {
  return repository.getAll();
};
